import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { catchError, map } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';

@Injectable({
  providedIn: 'root',
})
export class UserSecurityQuestionsService {
  public profileApi: string;

  public CONSUMER_CODE = '1000';

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.profileApi = `${secureApi}/profile/v2`;
  }

  getSecurityQuestions() {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.CONSUMER_CODE,
    );
    return this.http
      .get(`${this.profileApi}/secQuestions`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res: any) => res.securityQuestions),
        catchError(logError),
      );
  }
}
